<template>
  <screener-frame>
    <screener-title title="Your Results" />

    <block-result
      :level="riskLevel"
      :name="contact.firstName"
      :doctor="$auth.$state.profile.lastName"
    />

    <screener-result-img
      :title="'Risk level - ' + riskLevel"
      :level="riskLevel"
    />

    <p class="title">
      Thank you for completing the survey.
      Please return the device to your provider.
    </p>

    <template #actions>
      <v-spacer />

      <v-btn
        class="button-next"
        color="primary"
        to="/doctor"
        :loading="submitting"
      >
        Next
        <v-icon>mdi-chevron-double-right</v-icon>
      </v-btn>
    </template>
  </screener-frame>
</template>

<script>
import {
  contact,
  riskLevel,
  submitting,
  submitScreener
} from '@/use/screener'
import { onMounted } from '@vue/composition-api'

export default {
  setup: () => {
    onMounted(submitScreener)

    return {
      contact,
      riskLevel,
      submitting
    }
  }
}
</script>
